import { useQuery } from "@tanstack/react-query";
import React from "react";
import ReactPlayer from "react-player";

interface Props {
  src: string;
  width: number;
  height: number;
  fallback: JSX.Element;
}

const CachedSignedVideo = (props: Props) => {
  const actualUrl = props.src.split("?")[0];

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["cached-signed-video", actualUrl],
    queryFn: async () => {
      const response = await fetch(props.src);
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    },
    staleTime: Infinity,
  });

  if (query.isLoading) {
    return props.fallback;
  }

  if (query.error) {
    return props.fallback;
  }

  if (query.data !== undefined) {
    return <ReactPlayer url={query.data} width="100%" height="100%" controls={true} muted={true} />;
  }

  return null;
};

export default CachedSignedVideo;
